export default __webpack_public_path__ + "static/media/oi_logo.fd0a41e8.png";